import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    heading: 'Montserrat, sans-serif'
  },
  colors: {
    magenta: {
      50: '#ffe6ed',
      100: '#ffb3c4',
      200: '#fb809b',
      300: '#f94d72',
      400: '#f72255',
      500: '#fa0069',
      600: '#d9005a',
      700: '#b2004a',
      800: '#8e003b',
      900: '#6b002c'
    },
    abraYellow: {
      50: '#fff9e6',
      100: '#ffedbf',
      200: '#ffe198',
      300: '#ffd571',
      400: '#ffca48',
      500: '#fedc00',
      600: '#d9c400',
      700: '#b2a300',
      800: '#8c8200',
      900: '#665100'
    },
    abraGreen: {
      50: '#F2FCE8',
      100: '#DCF7C0',
      200: '#C5F197',
      300: '#AEEC6F',
      400: '#98E746',
      500: '#67B418',
      600: '#60a816',
      700: '#4D8712',
      800: '#345A0C',
      900: '#1A2D06'
    },
    abraPurple: {
      50: '#F4EBF9',
      100: '#DFC8EF',
      200: '#CAA4E4',
      300: '#B681DA',
      400: '#A15DD0',
      500: '#722fa0',
      600: '#702E9E',
      700: '#542376',
      800: '#38174F',
      900: '#1C0C27'
    },
    abraGray: {
      50: '#888888',
      100: '#777777',
      200: '#666666',
      300: '#555555',
      400: '#444444',
      500: '#333333',
      600: '#2E2E2E',
      700: '#1F1F1F',
      800: '#171717',
      900: '#1A1A1A'
    }
  },
  components: {
    Button: {
      variants: {
        magenta: {
          bg: 'magenta.500',
          color: 'white',
          _hover: {
            bg: 'magenta.600',
            _disabled: {
              bg: 'magenta.500'
            }
          },
          _active: {
            bg: 'magenta.700'
          },
          _focus: {
            boxShadow: '0 0 0 3px rgba(139,46,139,0.6)'
          }
        }
      }
    }
  }
})

export default theme
